<!--商品详情-->
<template>
<div class="productDetailContent">
        <div class="page-item">
            <div class="content productshow">
                <div class="content-left">
                    <div class="infobox">
                        <div class="img">
                            <div class="mainimg">                                                        
                                <img :src="big"  :alt="product.name" />
                                <div class="playbtn"  v-if="defaultImg==big&&productVideo!=''&&productVideo!=null" @click="showVideo(productVideo, product.name+'视频')"></div>
                            </div>
                            <div class="imglist">
                                <ul>
                                    <li v-for="(item,i) in small" :key="i" :class="big==item?'on':''" @click="setBig(i)" v-if="i<6">
                                      <img :src="item" :alt="product.name">
                                    </li>                                  
                                </ul>
                            </div>                            
                        </div>
                        <div class="info">
                            <div class="pDetail t">
                                {{product.name}}
                            </div>
                            <div class="pDetail tags">
                                <span>经典</span>
                                <span>潮流</span>
                            </div>
                            <div class="pDetail price">
                                <div class="price1">原价：<span>￥{{sellPrice.toFixed(2)}}</span></div>
                                <div class="price2">现售价：<span>￥{{settlementPrice.toFixed(2)}}</span></div>
                            </div>
                            <div class="pDetail sku" v-for="(item,i) in frontendPropertyInfo"  :key="i">
                                <div class="t">
                                  {{item.name}}：
                                </div>
                                <ul>
                                    <li v-for="(p,j) in item.propertyDetails"  :key="j" :class="(p.disable==true?'disableSpec ':'')+ (p.current==true?'on':'')"  @click="p.disable==true?selAttr1():selAttr(i,j)">
                                        {{p.name}}
                                    </li>                                    
                                </ul>
                            </div>                    
                            <div class="pDetail num">
                                <div class="t">
                                    数量：
                                </div>
                                <div class="numbox">
                                    <span @click="reduceNum">
                                        -
                                    </span>
                                    <input type="text" v-model="num"  @change="changeNum"/>
                                    <span @click="addNum">
                                        +
                                    </span>                                   
                                </div>
                                <div class="t">
                                  库存剩余({{stockNum}})
                                </div>
                            </div>
                            <div class="pDetail btns">
                                <a class="buy">立即购买</a>
                                <a class="addcar">加入购物车</a>
                            </div>
                        </div>
                    </div>
                    <div class="desbox">
                        <div class="nav">
                            <ul>
                                <li class="on">商品详情</li>
                                <!-- <li>累积评价(5)</li> -->
                            </ul>
                        </div>
                        <div class="navbox">
                            <div class="navbox-content ql-editor" v-html="productMsg">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-right">
                    <div class="title">商城热卖</div>
                    <ul>
                        <li v-for="(item,i) in productList" :key="i">
                                <img :src="item.defaultImage" @click="toDetail(item.id)"/>
                                <div>
                                    <span class="price1">
                                        ￥{{item.settlementPrice.toFixed(2)}}
                                    </span>
                                    <span class="price2">
                                        ￥{{item.sellPrice.toFixed(2)}}
                                    </span>
                                </div>
                                <div class="ptitle" @click="toDetail(item.id)">
                                    {{item.name}}
                                </div>                     
                        </li>                        
                    </ul>
                </div>
            </div>
        </div>
        <videoShow ref="videoShow"></videoShow>
</div>
</template>
<style>
@import '../../styles/productDetail.css';
@import '../../styles/md-toolbar.scss';
@import '../../styles/vue2-editor.scss';
</style>
<script>
  import { getProducts, getWaitAuditProduct } from '@/api/productDetail'
  import api from '@/api'
  import { mapMutations, mapState } from 'vuex'
  import { getStore, setStore} from '@/utils/storage'
  import VideoShow from '@/components/VideoShow'
  export default {
    name: 'goodsDetails',
    data () {
      return {
        productMsg: {},
        small: [],
        smallIndex:0,
        big: '',
        defaultImg:'',
        product: {},
        settlementPrice:0,
        sellPrice:0,
        helpFund:0.00,
        num: 1,
        userId: '',
        sourceFrontendPropertyInfo:[],
        frontendPropertyInfo:[],
        stockNum:0,
        selectIndexArray:[],
        selectIdAttrray:[],
        productList:[],
        productVideo:'',
        showGotop:false
      }
    },
    computed: {
      ...mapState(['isLogined'])
    },
    methods: {
      ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),    
      toDetail(id)
      {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },
      carouselImg()
      {
          this.smallIndex += 1;
          if(this.smallIndex>=6||this.smallIndex>=this.small.length)
          {
             this.smallIndex=0;
          }
         if(this.small.length>0&&this.small.length>this.smallIndex)  this.big = this.small[this.smallIndex];
         var _this = this;
         setTimeout(() => {
              _this.carouselImg()
            }, 5000)
      },
      setBig(index)
      {
        this.smallIndex=index;
        this.big = this.small[index];
      },
      _productDet (productId) {
        var _this=this;
        getWaitAuditProduct({id:productId}).then(res => {
          if (res.data.success === true) {
            this.product = res.data.result
            this.productMsg = res.data.result.description || ''
            this.small = res.data.result.productImages
            this.settlementPrice = res.data.result.productSpecs[0].settlementPrice
            this.sellPrice = res.data.result.productSpecs[0].sellPrice
            this.frontendPropertyInfo = this.product.frontendPropertyInfo
            this.productVideo = this.product.productVideo;
            this.stockNum =  this.product.productSpecs[0].quantity,
            this.helpFund = this.product.helpFund;
            this.big = this.small[0]
            this.defaultImg = this.small[0]
            this.disableSpec()
            setTimeout(() => {
              _this.carouselImg()
            }, 5000)
          }
        })
      },
      showVideo(url, title) {
        this.$refs['videoShow'].show(url, title)
      },
      async _products()
      {
        var param = {
          sorting:'sales',
          skipCount: 0,
          maxResultCount: 5,
        };
        await getProducts(param).then(res=>{
          if (res.data.success === true) {
            this.productList = res.data.result.items;
          }

        });
      },
      reduceNum()
      {
        this.num--;
        if(this.num<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          return;
        }
      },
      addNum()
      {
         this.num++;
        if(this.num>this.stockNum)
        {
          this.$message({ message: '数量不可大于库存', type: 'error', customClass: 'c-msg' }) 
          this.num=this.stockNum;
          return;
        }
      },
     changeNum()
     {      
      var myreg=/^\+?[1-9]\d*$/;
        if(!myreg.test(this.num))
        {
          this.$message({ message: '数量格式不对', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          if(this.stockNum==0)this.num=0;
          return;
        }
      if(this.num==''||this.num==undefined|| parseInt(this.num)>this.stockNum)
        {
          this.$message({ message: '数量不可为空，且不得大于库存', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          if(this.stockNum==0)this.num=0;
          return;
        }
        if(parseInt(this.num)<=0)
        {
          this.$message({ message: '数量必须大于0', type: 'error', customClass: 'c-msg' }) 
          this.num=1;
          return;
        }
    },
      showTop(){
         this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
         
          if(this.scroll>500){
            this.showGotop = true
          }else{
            this.showGotop = false
          }
      },
      goTop(){
        console.log(2222)
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },     
     
      editNum (num) {
         if(num <=0){
           num = 1
         }
        this.num = num
       
      },
      checkAttr(){

        var productSpecs = this.product.productSpecs; //原始规格数据
        //判断是否所以规格组都选中
        var frontendPropertyInfo = this.frontendPropertyInfo;
        var tips = ''
        var selectAttrid = []

        for (var i = 0; i < frontendPropertyInfo.length; i++) {
            if (this.selectIndexArray.indexOf(i) < 0) {
                tips = '请选择' + frontendPropertyInfo[i].name

            }
            var propertyDetails = frontendPropertyInfo[i].propertyDetails;
            for (var j = 0; j < propertyDetails.length; j++) {
                if (propertyDetails[j].current) {
                    selectAttrid.push(propertyDetails[j].id)
                }
            }
        }
        if (tips) {
            this.showErrorMsg(tips)
            return false
        }

        var specId = productSpecs[0].id;
        //从原始数据中找到相应规格组
        for (var i = 0; i < productSpecs.length; i++) {
            var tmp = []
            for (var y = 0; y < productSpecs[i].productPropertyInfo.length; y++) {
                tmp.push(productSpecs[i].productPropertyInfo[y].vid);
            }
            if (tmp.sort().toString() == selectAttrid.sort().toString()) {
                specId = productSpecs[i].id //规格id
                if (productSpecs[i].quantity <= 0) {
                    this.showErrorMsg('该规格库存不足')
                    return;
                }
            }
        }
        if (specId == 0) {
          this.showErrorMsg('请选择规格')
          return false
        }
        return specId 

      },
      disableSpec()
      {
        var count = this.frontendPropertyInfo.length;
        var product = this.product      

        if(count==1)
        {          
            var main = this.frontendPropertyInfo[0].propertyDetails;
            if(main&&main.length>0)
            {
               for(var m=0;m<main.length;m++)
               {
                  var sub = main[m] ;
                  var tempStockNum=0;
                  var tempselectAttrid=[];
                  tempselectAttrid.push(sub.id);

                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                      tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
                    }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity;           
                    }
                  }
                   
                  if(tempStockNum==0)
                  {
                     this.frontendPropertyInfo[0].propertyDetails[m].disable = true;
                  }
                  else
                  {
                     this.frontendPropertyInfo[0].propertyDetails[m].disable = false;
                  }
               }
            }         
        }      
        if(count==2)
        { 
          if(this.selectIndexArray.length==0)
          {
             for(var i=0;i<this.frontendPropertyInfo.length;i++)
             {
                 for(var j=0;j<this.frontendPropertyInfo[i].propertyDetails.length;j++)
                 {
                  this.frontendPropertyInfo[i].propertyDetails[j].disable=false;
                 }
             }
          }
          if(this.selectIndexArray.length==1)
          { 
            var main = this.frontendPropertyInfo[0].propertyDetails;
            var main1 = this.frontendPropertyInfo[1].propertyDetails;
            if(this.selectIndexArray[0]==0)
            {
              for(var i=0;i<main1.length;i++)
              {
                this.frontendPropertyInfo[1].propertyDetails[i].disable=false;
              }
              main = this.frontendPropertyInfo[1].propertyDetails;
            }
            else
            {
              for(var i=0;i<main.length;i++)
              {
                this.frontendPropertyInfo[0].propertyDetails[i].disable=false;
              }
            }
            if(main&&main.length>0)
            {
              for(var m=0;m<main.length;m++)
              {               
                  var sub = main[m];               
                  var tempStockNum=0;
                  var tempselectAttrid=[];
                  tempselectAttrid.push(this.selectIdAttrray[0]);
                  tempselectAttrid.push(sub.id);

                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                      tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
                    }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity
                      break;          
                    }
                  }
                   
                  if(tempStockNum==0)
                  {
                    if(this.selectIndexArray[0]==0)
                    {
                      this.frontendPropertyInfo[1].propertyDetails[m].disable = true;
                    }
                    else
                    {
                      this.frontendPropertyInfo[0].propertyDetails[m].disable = true;
                    }
                  }
                  else
                  {
                    if(this.selectIndexArray[0]==0)
                    {
                      this.frontendPropertyInfo[1].propertyDetails[m].disable = false;
                    }
                    else
                    {
                      this.frontendPropertyInfo[0].propertyDetails[m].disable = false;
                    }
                  }
                }           
              }
          }
          if(this.selectIndexArray.length==2)          
          {
            var main = this.frontendPropertyInfo[0].propertyDetails;
            var main1 = this.frontendPropertyInfo[1].propertyDetails;            
            if(main&&main.length>0&&main1&&main1.length>0)
            {
              for(var m=0;m<main.length;m++)
              {               
                  var sub = main[m];               
                  var tempStockNum=0;
                  var tempselectAttrid=[];
                  tempselectAttrid.push(this.selectIdAttrray[1]);
                  tempselectAttrid.push(sub.id);

                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                      tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
                    }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity
                      break;             
                    }
                  }
                   
                  if(tempStockNum==0)
                  {                   
                    this.frontendPropertyInfo[0].propertyDetails[m].disable = true;                    
                  }
                  else
                  {                    
                    this.frontendPropertyInfo[0].propertyDetails[m].disable = false;                    
                  }
              }   
              for(var m=0;m<main1.length;m++)
              {               
                  var sub = main1[m];               
                  var tempStockNum=0;
                  var tempselectAttrid=[];
                  tempselectAttrid.push(this.selectIdAttrray[0]);
                  tempselectAttrid.push(sub.id);

                  for (var i = 0; i < product.productSpecs.length; i++) 
                  {
                    var tmp = []
                    for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                      tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
                    }
                    if (tmp.sort().toString() == tempselectAttrid.sort().toString()) 
                    {               
                      tempStockNum = product.productSpecs[i].quantity
                      break;          
                    }
                  }
                   
                  if(tempStockNum==0)
                  {                   
                    this.frontendPropertyInfo[1].propertyDetails[m].disable = true;                    
                  }
                  else
                  {                    
                    this.frontendPropertyInfo[1].propertyDetails[m].disable = false;                    
                  }
              }        
            }
          }
        }
      },
      selAttr1 ()
      {},
      selAttr (index,jj) {
        var count = this.frontendPropertyInfo[index].propertyDetails.length;
        var selectIndexArray = this.selectIndexArray
        for (var i = 0; i < count; i++) {
            if(i==jj)
            {
              if(this.frontendPropertyInfo[index].propertyDetails[i].current==true)
              {
                this.frontendPropertyInfo[index].propertyDetails[i].current=false;
                if (selectIndexArray.indexOf(index) >-1) {
                  var tempIndex = selectIndexArray.indexOf(index);
                  selectIndexArray.splice(tempIndex,1)
                }
              }
              else
              {
                this.frontendPropertyInfo[index].propertyDetails[i].current=true;
                if (selectIndexArray.indexOf(index) < 0) {
                  selectIndexArray.push(index)
                }
              }
            }
            else
            {
              this.frontendPropertyInfo[index].propertyDetails[i].current = false;
            }
        }      
       
        var selectAttrid = []
        for (var i = 0; i < this.frontendPropertyInfo.length; i++) {
            var propertyDetails = this.frontendPropertyInfo[i].propertyDetails;
            for (var j = 0; j < propertyDetails.length; j++) {
                if (propertyDetails[j].current) {
                    selectAttrid.push(propertyDetails[j].id)
                }
            }
        }
        this.selectIdAttrray = JSON.parse(JSON.stringify(selectAttrid));
        var product = this.product

        var stockNum = this.stockNum
       
        var settlementPrice = this.settlementPrice    
        var sellPrice = this.sellPrice
            //从原始数据中找到相应规格组
        for (var i = 0; i < product.productSpecs.length; i++) {
            var tmp = []
            for (var y = 0; y < product.productSpecs[i].productPropertyInfo.length; y++) {
                tmp.push(product.productSpecs[i].productPropertyInfo[y].vid);
            }
            if (tmp.sort().toString() == selectAttrid.sort().toString()) {
                settlementPrice = product.productSpecs[i].settlementPrice
                stockNum = product.productSpecs[i].quantity
                sellPrice = product.productSpecs[i].sellPrice
            }
        }
        this.stockNum = stockNum
        if(this.num>this.stockNum)this.num=this.stockNum;
        this.selectIndexArray = selectIndexArray       
        this.settlementPrice = settlementPrice
        this.sellPrice = sellPrice
        this.disableSpec();
        this.$forceUpdate();
      },
      showErrorMsg(msg){
        this.$message({
              message: msg,
              type: 'error',
              customClass: 'c-msg',
              duration: 1000,
              showClose: true
            })
      }
    },
    components: {      
      VideoShow
    },
    mounted() {
      window.addEventListener('scroll', this.showTop)
    },
    created () {
      let id = this.$route.query.productId
      this._productDet(id)
      this._products();
      this.userId = getStore('userId')      
    }
  }
</script>


// WEBPACK FOOTER //
// waitAuditGoodsDetails.vue?22bf4c38